import React from 'react';
import { useLocation } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { SocialLink } from '../ui/SocialIcon';

export function Footer() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  if (isAdminPage) {
    return null;
  }

  return (
    <footer className="bg-gray-900 text-white py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold mb-4">
            Your journey to wedding success starts here
          </h3>
          <p className="text-gray-400">
            Follow us on TikTok for updates and tips!
          </p>
        </div>
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-8">
          <SocialLink
            type="email"
            href="mailto:administration@weddingwalliyan.com"
            label="administration@weddingwalliyan.com"
          />
          <SocialLink
            type="tiktok"
            href="https://tiktok.com/@weddingwalliyan"
            label="@weddingwalliyan"
          />
        </div>
        <div className="text-center text-gray-400 flex items-center justify-center gap-2">
          <span>Made with</span>
          <Heart className="w-4 h-4 text-rose-500" />
          <span>by WeddingWalliyan</span>
        </div>
      </div>
    </footer>
  );
}